import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatMonthYear'
})
export class FormatMonthYearPipe implements PipeTransform {
  transform(value: string): string {
    if (!value || value.length <= 4) {
      return value;
    }

    const month = value.slice(0, value.length - 4).toLowerCase();
    const year = value.slice(-4);

    // Capitalize first letter of month
    const capitalizedMonth = month.charAt(0).toUpperCase() + month.slice(1);

    return `${capitalizedMonth} ${year}`;
  }
}
